<script setup lang="ts">
import { useLayout } from '@/composable/useLayout'
import AppNavbar from '@/core/AppNavbar.vue'
import { cn } from '@/utils'
import { computed } from 'vue'

const { layoutState } = useLayout()

const wrapperMainContainerClasses = computed(() => {
  return cn(
    'wrapper-main-container',
    { '!ml-0': !layoutState.sidebarVisible.value },
    { 'max-h-screen': layoutState.sidebarVisible.value },
  )
})
</script>

<template>
  <div :class="wrapperMainContainerClasses">
    <AppNavbar />
    <div class="flex flex-1 flex-col overflow-y-auto">
      <slot />
    </div>
  </div>
</template>

<style lang="postcss">
.wrapper-main-container {
  @apply flex h-screen min-h-screen flex-col justify-between pb-3 pl-16 pr-8 pt-4 transition-[margin-left] duration-200 lg:ml-sidebar;
}
</style>
